import { selectEntireState } from '@/app/state/selectors';
import { createSelector } from '@ngrx/store';
import { State } from '@state/model';

const selectPPTParcelEntity = (s: State) => s.common.ppt.entities.parcels;

export const selectPPTParcelsById = createSelector(selectPPTParcelEntity, s => s.entities);
export const selectPPTParcel = (id: string) => createSelector(selectPPTParcelsById, parcelsById => parcelsById[id]);


// Addresses
//
// There are different ways of getting the address. We should probably have two one for full multiline address
// and one for single line addresses, or maybe a single, configurable selector.
//
// There are also two sources of truth for a parcel's address: `address: PPTParcelAddress` and `fullAddress: string`.
// We probably need to use only one, but that requires backend work.

export const selectPPTParcelAddress = (id: string, includeZip = true) => createSelector(
    selectPPTParcelsById,
    parcelsById =>
    {
        const parcel = parcelsById[id];

        let result = '';

        if (parcel?.address)
        {
            const address1And2 =
                [parcel.address.address1, parcel.address.address2].filter(value => !!value).join(' ').trim();

            if (address1And2.length) result += address1And2 + '\n';

            if (parcel.address.city || parcel.address.state || parcel.address.zip)
            {
                if (parcel.address.city)
                {
                    result += parcel.address.city;

                    if (parcel.address.state || includeZip && parcel.address.zip)
                        result += ', ';
                }

                if (parcel.address.state) result += parcel.address.state + ' ';
                if (includeZip && parcel.address.zip) result += parcel.address.zip;

                result += '\n';
            }
        }

        if (result.length)
            return result.trim();
    }
);

export const selectPPTParcelAddressForLookupResult = (id: string, includeZip = true) => createSelector(
    selectPPTParcelsById,
    parcelsById =>
    {
        const parcel = parcelsById[id];

        let result: string | undefined;

        if (parcel?.fullAddress)
            result = parcel?.fullAddress;
        else
        {
            const address = parcel?.address;

            if (address)
            {
                if (address.address1 || address.address2)
                {
                    const address1And2 = [address.address1, address.address2].filter(value => !!value).join(' ').trim();

                    result = address.state
                        ? `${address1And2}, ${address.state}`
                        : address1And2;
                }
                else if (address.state)
                    result = address.state;
            }
        }

        return result?.trim();
    }
);


export const selectPPTParcelHasAddressForLookupResult = (id: string) => createSelector(
    selectEntireState,
    s =>
    {
        const address = selectPPTParcelAddressForLookupResult(id)(s);
        return address && !!address?.length;
    }

);
